import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, Stack, Autocomplete } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CVHttpService } from '../../services';

function SkillFormDialog({ open, onClose, onSave, cvId, skill }) {
    const [skillsList, setSkillsList] = useState([]);
    const [loadingSkills, setLoadingSkills] = useState(false);

    const { register, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm({
        defaultValues: skill || {
            title: '',
            years_of_experience: '',
            skill: null
        }
    });

    useEffect(() => {
        if (open) {
            loadSkills();
            if (skill) {
                reset({
                    title: skill.title || '',
                    years_of_experience: skill.years_of_experience || '',
                    skill: skill.skill || null
                });
            } else {
                reset({
                    title: '',
                    years_of_experience: '',
                    skill: null
                });
            }
        }
    }, [skill, open, reset]);

    const loadSkills = async () => {
        setLoadingSkills(true);
        try {
            const service = new (await import('core/services/http')).HttpService();
            const data = await service.get('/job/cv/skill/', null);
            const skills = Array.isArray(data) ? data : (data?.results || []);
            setSkillsList(skills);
        } catch (err) {
            console.error('Failed to load skills', err);
        } finally {
            setLoadingSkills(false);
        }
    };

    const selectedSkill = watch('skill');

    const onSubmit = async (data) => {
        try {
            const body = {
                ...data,
                id: skill?.id || null,
                cv: cvId,
                skill: data.skill && typeof data.skill === 'object' ? data.skill.id : data.skill,
                user: null
            };
            await CVHttpService.saveUserSkill(body);
            onSave();
        } catch (err) {
            alert('Failed to save skill');
            console.error(err);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>{skill ? 'Edit Skill' : 'Add Skill'}</DialogTitle>
                <DialogContent>
                    <Stack spacing={3} sx={{ mt: 1 }}>
                        <TextField
                            fullWidth
                            label="Skill Name *"
                            {...register('title', { required: 'Skill name is required' })}
                            error={!!errors.title}
                            helperText={errors.title?.message}
                        />
                        <Autocomplete
                            options={skillsList}
                            getOptionLabel={(option) => option.title || option}
                            value={selectedSkill || null}
                            onChange={(event, newValue) => {
                                setValue('skill', newValue, { shouldValidate: true });
                            }}
                            loading={loadingSkills}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Skill Category (Optional)"
                                    placeholder="Select a skill category"
                                />
                            )}
                        />
                        <TextField
                            fullWidth
                            label="Years of Experience"
                            type="text"
                            {...register('years_of_experience')}
                            placeholder="e.g., 5, 3-5, 2+"
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="submit" variant="contained">Save</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default SkillFormDialog;

